import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class DepositoEfectivoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  guardarDepositoEfectivo(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: deposito_efectivoInputType, $resumen: control_resumidoInputType) {
          deposito_efectivo {
            guardarDepositoEfectivo(entidad: $entidad, resumen: $resumen) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                empresa_rut
                sucursal_codigo
                tipo_cuenta_bancaria_codigo
                banco_codigo
                numero_cuenta
                depositante_codigo
                fecha_deposito
                estado
                monto
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.deposito_efectivo.guardarDepositoEfectivo
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: deposito_efectivoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          deposito_efectivo {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  tipo_cuenta_bancaria_codigo
                  banco_codigo
                  banco_nombre
                  numero_cuenta
                  fecha_deposito
                  fecha_timbrado
                  estado
                  monto
                  depositante_codigo
                  depositante_rut
                  depositante_nombre
                  numero_deposito
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.deposito_efectivo.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  timbradoDepositoEfectivo(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: deposito_efectivoInputType) {
          deposito_efectivo {
            timbadoDepositoEfectivo(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  tipo_cuenta_bancaria_codigo
                  banco_codigo
                  banco_nombre
                  numero_cuenta
                  fecha_deposito
                  fecha_timbrado
                  estado
                  monto
                  depositante_codigo
                  depositante_rut
                  depositante_nombre
                  numero_deposito
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.deposito_efectivo.timbadoDepositoEfectivo
        callback({ mensajes, respuesta })
      }
    );
  }
}
